import chunk from 'lodash/chunk';
/* Types */
import { Review as ReviewType } from 'src/types/reviews.types';
/* Components & Styles */
import Review from 'src/components/UI/Review';
import { Grid } from 'ht-styleguide';
import styles from './customerReviewPage.module.scss';

const defaultReviewsObject = { featured: [] as ReviewType[], skus: [] as ReviewType[] };
const CustomerReviewsPage = ({ reviews = defaultReviewsObject }) => (
  <Grid.Fluid classes="paddingY-medium1">
    <h1 className="paddingBottom-medium">Customer Reviews</h1>
    <section>
      {chunk(reviews.skus, 2).map((row, rowIndex) => (
        <Grid.Row key={rowIndex}>
          {row.map((review, reviewIndex) => (
            <Grid.Column sm={4} md={4} lg={6} classes="marginBottom-medium1" key={reviewIndex}>
              <Review review={review} className={styles.mappedReview} />
            </Grid.Column>
          ))}
        </Grid.Row>
      ))}
    </section>
  </Grid.Fluid>
);

export default CustomerReviewsPage;
